// Mock data for CR Home Interior Design Landing Page

export const mockProjects = [
  {
    id: '1',
    clientName: 'María González',
    projectName: 'Departamento Playa del Carmen',
    progress: 60,
    phases: [
      { name: 'Briefing y levantamiento', status: 'completed' },
      { name: 'Propuesta de diseño', status: 'completed' },
      { name: 'Ajustes', status: 'in-progress' },
      { name: 'Producción / Mobiliario', status: 'pending' },
      { name: 'Entrega', status: 'pending' }
    ],
    email: 'maria@example.com',
    phone: '+52 984 123 4567'
  },
  {
    id: '2',
    clientName: 'Roberto Sánchez',
    projectName: 'Villa Tulum',
    progress: 85,
    phases: [
      { name: 'Briefing y levantamiento', status: 'completed' },
      { name: 'Propuesta de diseño', status: 'completed' },
      { name: 'Ajustes', status: 'completed' },
      { name: 'Producción / Mobiliario', status: 'completed' },
      { name: 'Entrega', status: 'in-progress' }
    ],
    email: 'roberto@example.com',
    phone: '+52 984 234 5678'
  }
];

export const mockProveedores = [];

export const mockClientesProveedor = [];

// Language translations
export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      clients: 'Soy cliente',
      suppliers: 'Soy proveedor',
      contact: 'Contacto',
      clientAccess: 'Acceso clientes',
      bookAppointment: 'Agenda tu cita'
    },
    hero: {
      title: 'Interiorismo y arquitectura a medida',
      subtitle: 'Tu espacio es una expresión de tu identidad y estilo de vida; acompañado por una visión que lo convierte en un lugar de significado.',
      ctaClient: 'Soy cliente',
      ctaSupplier: 'Soy proveedor'
    },
    clients: {
      title: 'Área de Clientes',
      intro: 'Si ya eres cliente de CR Home, aquí puedes consultar el avance de tu proyecto de diseño de interiores.',
      loginTitle: 'Acceso a tu proyecto',
      email: 'Email',
      phone: 'Teléfono o ID de proyecto',
      loginButton: 'Ver mi proyecto',
      dashboardTitle: 'Tu Proyecto',
      progress: 'Progreso del proyecto',
      timeline: 'Línea de tiempo',
      phases: {
        briefing: 'Briefing y levantamiento',
        proposal: 'Propuesta de diseño',
        adjustments: 'Ajustes',
        production: 'Producción / Mobiliario',
        delivery: 'Entrega'
      }
    },
    suppliers: {
      title: 'Área de Proveedores',
      intro: 'Si eres proveedor de mobiliario, acabados o servicios complementarios, regístrate para colaborar con CR Home y registra a tus clientes.',
      registerTitle: 'Registro de Proveedor',
      companyName: 'Nombre del proveedor o empresa',
      contactName: 'Nombre de contacto',
      phone: 'Teléfono',
      email: 'Email',
      type: 'Tipo de proveedor',
      city: 'Ciudad / Ubicación',
      registerButton: 'Registrarme como proveedor',
      successMessage: '¡Gracias! Tu registro como proveedor ha sido recibido. En breve un miembro del equipo de CR Home se pondrá en contacto contigo.',
      clientRegisterTitle: 'Registrar Clientes',
      clientFullName: 'Nombre completo del cliente',
      clientPhone: 'Teléfono',
      clientEmail: 'Email',
      projectLocation: 'Ubicación del proyecto a decorar',
      notes: 'Comentarios / Notas',
      saveClientButton: 'Guardar cliente',
      clientSavedMessage: 'Cliente guardado exitosamente',
      registeredClients: 'Clientes Registrados',
      types: {
        furniture: 'Mobiliario',
        finishes: 'Acabados',
        lighting: 'Iluminación',
        art: 'Arte',
        textiles: 'Textiles',
        other: 'Otro'
      }
    },
    contact: {
      title: 'Contacto',
      name: 'Nombre',
      email: 'Email',
      message: 'Mensaje',
      sendButton: 'Enviar',
      successMessage: 'Mensaje enviado. Nos pondremos en contacto pronto.',
      phone: 'Teléfono',
      location: 'Ubicación'
    },
    footer: {
      rights: 'Todos los derechos reservados.',
      privacy: 'Política de privacidad',
      terms: 'Términos y condiciones'
    }
  },
  en: {
    nav: {
      home: 'Home',
      clients: 'I am a client',
      suppliers: 'I am a supplier',
      contact: 'Contact',
      clientAccess: 'Client Access',
      bookAppointment: 'Book Appointment'
    },
    hero: {
      title: 'Custom Interior Design & Architecture',
      subtitle: 'Your space is an expression of your identity and lifestyle; accompanied by a vision that transforms it into a place of meaning.',
      ctaClient: 'I am a client',
      ctaSupplier: 'I am a supplier'
    },
    clients: {
      title: 'Client Area',
      intro: 'If you are already a CR Home client, here you can check the progress of your interior design project.',
      loginTitle: 'Access your project',
      email: 'Email',
      phone: 'Phone or Project ID',
      loginButton: 'View my project',
      dashboardTitle: 'Your Project',
      progress: 'Project progress',
      timeline: 'Timeline',
      phases: {
        briefing: 'Briefing and survey',
        proposal: 'Design proposal',
        adjustments: 'Adjustments',
        production: 'Production / Furniture',
        delivery: 'Delivery'
      }
    },
    suppliers: {
      title: 'Supplier Area',
      intro: 'If you are a furniture, finishes or complementary services supplier, register to collaborate with CR Home and register your clients.',
      registerTitle: 'Supplier Registration',
      companyName: 'Supplier or company name',
      contactName: 'Contact name',
      phone: 'Phone',
      email: 'Email',
      type: 'Supplier type',
      city: 'City / Location',
      registerButton: 'Register as supplier',
      successMessage: 'Thank you! Your supplier registration has been received. A member of the CR Home team will contact you shortly.',
      clientRegisterTitle: 'Register Clients',
      clientFullName: 'Client full name',
      clientPhone: 'Phone',
      clientEmail: 'Email',
      projectLocation: 'Project location to decorate',
      notes: 'Comments / Notes',
      saveClientButton: 'Save client',
      clientSavedMessage: 'Client saved successfully',
      registeredClients: 'Registered Clients',
      types: {
        furniture: 'Furniture',
        finishes: 'Finishes',
        lighting: 'Lighting',
        art: 'Art',
        textiles: 'Textiles',
        other: 'Other'
      }
    },
    contact: {
      title: 'Contact',
      name: 'Name',
      email: 'Email',
      message: 'Message',
      sendButton: 'Send',
      successMessage: 'Message sent. We will contact you soon.',
      phone: 'Phone',
      location: 'Location'
    },
    footer: {
      rights: 'All rights reserved.',
      privacy: 'Privacy policy',
      terms: 'Terms and conditions'
    }
  }
};